/**
 * Update a flow result's concern (RAG rating) and notify team leaders.
 *
 * This function performs a client-side skeem mutation followed by a server API call
 * to send notifications to team leaders.
 */
export async function updateResultRag(params: {
  resultId: string
  newConcern: string
  oldConcern: string
}) {
  const { resultId, newConcern, oldConcern } = params

  // Client-side mutation to update the concern
  await window.skeem.mutate({
    flowResults: {
      update: {
        id: resultId,
        concern: newConcern,
      },
    },
  })

  // Server-side notification to team leaders
  await window.api.notifyConcernChange({
    resultId,
    newConcern,
    oldConcern,
  })
}
